import Vue from 'vue';
import Vuex from 'vuex';
import firebase from 'firebase/app';
import 'firebase/database';
import user from './user';
import programs from './programs';
import donations from './donations';
import Locations from './locations';
import impact from './impact';
import about from './about';
import careers from './careers';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    status: {
      show: false,
      type: 'error',
      message: 'Some message'
    }
  },

  getters: {
    status: state => {
      return state.status;
    }
  },

  mutations: {
    showMessage(state, payload) {
      const defaults = {
        show: true,
        type: 'info'
      };
      state.status = { ...defaults, ...payload };
    },

    hideMessage(state, payload) {
      state.status = { ...state.status, ...payload };
    }
  },
  actions: {
    showMessage({ commit }, payload) {
      commit('showMessage', payload);
    },

    load({ commit }) {
      commit('showMessage', { message: 'Loading data from server...' });

      // Load only data
      firebase
        .database()
        .ref('/content')
        .once('value')
        .then(snapshot => {
          var allData = snapshot.val();

          // commit('loadDonations', allData.data.donations);
          commit('loadPrograms', allData.programs);
          commit('loadLocations', allData.locations);
          commit('loadImpact', allData.impact);
          commit('loadAbout', allData.about);
          commit('loadCareers', allData.careers);
          commit('hideMessage');
        })
        .catch(error => {
          commit('showMessage', {
            type: 'error',
            message:
              'Error loading Content data from server... Try relaoding the page'
          });
          console.log(error);
        });

      // Load & Watch data
      firebase
        .database()
        .ref('/data/donations/')
        .on('value', snapshot => {
          var allData = snapshot.val();
          commit('loadDonations', allData);
        });
    }
  },

  modules: {
    programs,
    donations,
    Locations,
    impact,
    about,
    careers,
    user
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js